import { useState, useEffect } from "react";
import { LuSearch, LuX, LuCheck } from "react-icons/lu";
import TransporterLayout from "../../components/TransporterLayout/TransporterLayout";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import LoadBidDrawer from "../../components/LoadBidDrawer/LoadBidDrawer";
import { fetchOpenLoads } from "../../lib/directus";
import styles from "./TransporterLoads.module.css";

function mapLoad(load) {
  const batch = load.order?.batch || {};
  return {
    _id: load.id,
    loadId: load.load_id || `#${load.id.slice(0, 8).toUpperCase()}`,
    pickup: load.pickup_location || '-',
    delivery: load.delivery_location || '-',
    commodity: batch.commodity || '-',
    grade:     batch.grade || '-',
    cargo: batch.commodity ? `${batch.commodity}${batch.grade ? ' (' + batch.grade + ')' : ''}` : '-',
    quantity: batch.quantity != null ? `${batch.quantity}${batch.unit_of_measure ? ' ' + batch.unit_of_measure : ' MT'}` : '-',
    distance: '-',
    pickupDate: '-',
    pickupWindow: '-',
    deliveryDeadline: '-',
    bidCloses: '-',
    estimatedTime: '-',
    bidsSubmitted: load.bids?.length || 0,
    seller: '-',
    sellerRating: 0,
    sellerTrades: 0,
  };
}

function SuccessModal({ onClose }) {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.modalClose} onClick={onClose}>
          <LuX size={18} />
        </button>
        <div className={styles.successIcon}>
          <LuCheck size={32} color="white" />
        </div>
        <p className={styles.successMsg}>Bid submitted!</p>
      </div>
    </div>
  );
}

export default function TransporterLoads() {
  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [route, setRoute] = useState("Routes");
  const [quantity, setQuantity] = useState("Quantity");
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    fetchOpenLoads()
      .then((data) => setLoads(data.map(mapLoad)))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = loads.filter(
    (load) =>
      load.pickup.toLowerCase().includes(search.toLowerCase()) ||
      load.delivery.toLowerCase().includes(search.toLowerCase()) ||
      load.cargo.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <TransporterLayout>
      <div className={styles.page}>
        {/* Toolbar */}
        <div className={styles.toolbar}>
          <h1 className={styles.pageTitle}>Load board</h1>
          <div className={styles.toolbarRight}>
            <div className={styles.searchWrap}>
              <LuSearch size={14} color="#9ca3af" />
              <input
                className={styles.searchInput}
                placeholder="Search loads..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <CustomSelect
              value={route}
              onChange={setRoute}
              options={["Routes", "Accra → Tema", "Kumasi → Accra", "Tamale → Tema"]}
            />
            <CustomSelect
              value={quantity}
              onChange={setQuantity}
              options={["Quantity", "10-30 MT", "30-50 MT", "50+ MT"]}
            />
          </div>
        </div>

        {/* Loads grid */}
        {loading ? (
          <p style={{ color: 'var(--secondary-text)', padding: '2rem' }}>Loading...</p>
        ) : filtered.length === 0 ? (
          <p style={{ color: 'var(--secondary-text)', padding: '2rem' }}>No loads available.</p>
        ) : (
          <div className={styles.grid}>
            {filtered.map((load) => (
              <div
                key={load._id}
                className={styles.loadCard}
                onClick={() => setSelectedLoad(load)}
              >
                {/* Load ID */}
                <div className={styles.cardHeader}>
                  <p className={styles.loadIdText}>{load.loadId}</p>
                </div>

                {/* Route section */}
                <div className={styles.cardBody}>
                  <div className={styles.routeRow}>
                    <div className={styles.pickupBlock}>
                      <span className={styles.routeLabel}>PICKUP</span>
                      <span className={styles.routeName}>{load.pickup}</span>
                    </div>
                    <span className={styles.routeArrow}>→</span>
                    <div className={styles.deliveryBlock}>
                      <span className={styles.routeLabel}>DELIVERY</span>
                      <span className={styles.routeName}>{load.delivery}</span>
                    </div>
                  </div>

                  <div className={styles.cardDivider} />

                  {/* Info rows */}
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Cargo</span>
                    <span className={styles.infoValue}>{load.cargo}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Distance</span>
                    <span className={styles.infoValue}>{load.distance}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Pickup date</span>
                    <span className={styles.infoValue}>{load.pickupDate}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Bids submitted</span>
                    <span className={styles.infoValue}>{load.bidsSubmitted}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <LoadBidDrawer
        load={selectedLoad}
        onClose={() => setSelectedLoad(null)}
        onSubmit={() => {
          setSelectedLoad(null);
          setShowSuccess(true);
        }}
      />

      {showSuccess && <SuccessModal onClose={() => setShowSuccess(false)} />}
    </TransporterLayout>
  );
}
